package com.essntl.features.profile.ui

import androidx.compose.animation.animateColorAsState
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.uikit.components.dropdown.EsDropDownMenu
import com.essntl.uikit.components.dropdown.EsDropdownMenuItem
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.tooltip.EsTooltip
import com.essntl.uikit.rememberFind
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun OwnerItem(
    profile: ProfileModel? = null,
    ownerId: String? = null,
    getAllProfile: State<List<ProfileModel>> = State(),
    isUpdateOwnerLoading: Boolean = false,
    enabled: Boolean,
    onOwnerChange: (ProfileModel) -> Unit,
    modifier: Modifier = Modifier,
) {
    var isSelectOwnerExpanded by remember {
        mutableStateOf(false)
    }

    val owner = profile
        ?: rememberFind(
            getAllProfile.data.orEmpty(),
            ownerId,
        ) { profile ->
            profile.id
        }

    val esColorScheme = MaterialTheme.esColorScheme
    val color by animateColorAsState(
        targetValue =
            if (owner != null)
                Color(0xFF3a88fe)
            else
                esColorScheme.borderPrimary,
    )

    EsTooltip(
        text = if (owner != null) "${owner.firstName} ${owner.lastName}" else "",
        modifier = modifier,
    ) {
        Box {
            Box(
                contentAlignment = Alignment.Center,
                modifier = Modifier
                    .size(40.dp)
                    .border(
                        width = 1.dp,
                        color = color,
                        shape = CircleShape,
                    )
                    .clip(CircleShape)
                    .focusProperties { canFocus = false }
                    .let {
                        if (enabled)
                            it.clickable(
                                enabled = !isUpdateOwnerLoading,
                            ) {
                                isSelectOwnerExpanded = true
                            }
                        else {
                            it
                        }
                    },
            ) {
                if (isUpdateOwnerLoading)
                    EsSpinner()
                else
                    Text(
                        text = owner?.initials ?: "X",
                        color = color,
                        style = MaterialTheme.esTypography.p2Medium14,
                        maxLines = 1,
                    )
            }

            EsDropDownMenu(
                expanded = isSelectOwnerExpanded,
                onDismissRequest = {
                    isSelectOwnerExpanded = false
                },
                modifier = Modifier.width(200.dp),
            ) {
                if (getAllProfile.isLoading)
                    EsSpinner(
                        modifier = Modifier
                            .align(Alignment.CenterHorizontally)
                            .padding(16.dp),
                    )
                else if (getAllProfile.isFailure)
                    Text(
                        text = "Failed to load users",
                        style = MaterialTheme.esTypography.p2Medium14,
                        modifier = Modifier
                            .padding(16.dp),
                    )
                else
                    getAllProfile.data?.forEach { user ->
                        EsDropdownMenuItem(
                            text = user.firstName.orEmpty() + " " + user.lastName.orEmpty(),
                            onClick = {
                                onOwnerChange(user)
                                isSelectOwnerExpanded = false
                            },
                        )
                    }
            }
        }
    }
}